<!-- src/app/menu/menu.component.html -->

@if (isRootNode) {
    <!-- <button mat-button [matMenuTriggerFor]="menu">
        {{ nodeData.menuText }}
    </button> -->
    <div style="visibility: hidden; position: fixed" [style.left]="contextMenuPosition.x" [style.top]="contextMenuPosition.y" [matMenuTriggerFor]="menu"></div>
} @else if (nodeData.childrenNodes && nodeData.childrenNodes.length !== 0) {
    <button mat-menu-item [matMenuTriggerFor]="menu" class="toto">
        {{ nodeData.text }}
    </button>
}
<mat-menu #menu="matMenu" class="multi-level-context-menu" [overlapTrigger]="false" [hasBackdrop]="true">
    @for (childNodeData of nodeData.childrenNodes; track childNodeData.text) {
        <ng-container>
            @if (childNodeData.childrenNodes && childNodeData.childrenNodes.length !== 0) {
                <button mat-menu-item style="padding: 0">
                    <app-multi-level-context-menu [nodeData]="childNodeData" (onContextMenuItemClick)="forwardContextMenuItemClick($event)"></app-multi-level-context-menu>
                </button>
            } @else {
                <button mat-menu-item (click)="onContextMenuClick($event, childNodeData)">{{ childNodeData.text }}</button>
            }
        </ng-container>
    }
</mat-menu>
